module.exports = __webpack_public_path__ + "static/media/add tour.dddebf77.svg";